export function exportCustomerTransferReportToPDF(
  transfers: any[],
  totalTransfers: number,
  currentCycleStart: string,
  currentCycleEnd: string
): void {
  const printWindow = window.open('', '_blank');
  if (!printWindow) {
    return;
  }

  const formatDate = (isoDate: string) => {
    if (!isoDate) {
      return '-';
    }
    const date = new Date(isoDate);
    if (isNaN(date.getTime())) {
      return isoDate;
    }
    const pad = (n: number) => String(n).padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  const areaDisplay = (t: any) => {
    if (t.areaName) {
      return `${t.areaName} (${t.areaCode})`;
    }
    return t.areaCode != null ? String(t.areaCode) : '-';
  };

  const columns = [
    { key: 'customerId', label: 'Customer ID', align: 'left' },
    { key: 'customerName', label: 'Customer Name', align: 'left' },
    { key: 'customerPhone', label: 'Phone', align: 'left' },
    { key: 'previousArea', label: 'From Area', align: 'left' },
    { key: 'newArea', label: 'To Area', align: 'left' },
    { key: 'transferredAt', label: 'Transfer Date', align: 'left' },
    { key: 'transferredBy', label: 'Transferred By', align: 'left' }
  ];

  const headerRow = '<tr>' + columns.map(col =>
    `<th style='text-align:${col.align}'>${col.label}</th>`
  ).join('') + '</tr>';

  const loggedInUser = localStorage.getItem('loggedInUser');
  const loggedInUserName = localStorage.getItem('loggedInUserName');
  const rows = transfers.map(t => {
    const fromArea = areaDisplay({ areaName: t.previousAreaName, areaCode: t.previousAreaCode });
    const toArea = areaDisplay({ areaName: t.newAreaName, areaCode: t.newAreaCode });
    const transferredBy = t.transferredBy === loggedInUser ? (loggedInUserName || t.transferredBy) :
      (t.transferredBy && t.transferredBy.toLowerCase() !== 'system' ? t.transferredBy :
        (loggedInUserName || loggedInUser || t.transferredBy || '-'));
    const values = [
      t.customerId != null ? t.customerId : '-',
      t.customerName || '-',
      t.customerPhone != null ? t.customerPhone : '-',
      fromArea,
      toArea,
      formatDate(t.transferredAt),
      transferredBy
    ];
    return '<tr>' + values.map((value, i) =>
      `<td style='text-align:${columns[i].align}'>${value}</td>`
    ).join('') + '</tr>';
  }).join('');

  const html = `<!DOCTYPE html>
<html>
<head>
  <title>Customer Transfer Report</title>
  <style>
    @page { size: landscape; margin: 12mm; }
    body { font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif; margin: 0; padding: 24px; color: #1a1a2e; background: #fff; }
    .header { display: flex; justify-content: space-between; align-items: flex-end; border-bottom: 3px solid #0f766e; padding-bottom: 14px; margin-bottom: 24px; }
    .header h1 { color: #0f766e; margin: 0; font-size: 26px; letter-spacing: 0.02em; }
    .header .subtitle { font-size: 13px; color: #64748b; margin-top: 6px; }
    .header .meta { text-align: right; font-size: 12px; color: #475569; line-height: 1.6; }
    .summary-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); gap: 14px; margin-bottom: 28px; }
    .summary-card { border-radius: 10px; padding: 14px 16px; background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%); border: 1px solid #99f6e4; box-shadow: 0 2px 6px rgba(15, 118, 110, 0.08); }
    .summary-card .label { font-size: 10px; text-transform: uppercase; color: #0f766e; margin-bottom: 8px; letter-spacing: 0.06em; font-weight: 600; }
    .summary-card .value { font-size: 17px; font-weight: 700; color: #111827; }
    h2 { color: #0f766e; font-size: 17px; margin-bottom: 12px; font-weight: 600; }
    table { width: 100%; border-collapse: separate; border-spacing: 0; font-size: 9.5px; margin-top: 10px; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.06); }
    th, td { border-bottom: 1px solid #e2e8f0; padding: 7px 8px; }
    th { background: #0f766e; color: #fff; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; }
    td { background: #fff; color: #1e293b; }
    tr:nth-child(even) td { background: #f8fafc; }
    tr:hover td { background: #f0fdfa; }
    .footer { margin-top: 28px; font-size: 10px; color: #94a3b8; text-align: center; border-top: 1px solid #e2e8f0; padding-top: 12px; }
  </style>
</head>
<body>
  <div class='header'>
    <div>
      <h1>Customer Transfer Report</h1>
      <div class='subtitle'>Xogta Beddelka Deegaanka — SomWater</div>
    </div>
    <div class='meta'>
      <div><strong>Period:</strong> ${currentCycleStart} — ${currentCycleEnd}</div>
      <div><strong>Generated:</strong> ${new Date().toLocaleString()}</div>
    </div>
  </div>
  <div class='summary-grid'>
    <div class='summary-card'>
      <div class='label'>Report Cycle</div>
      <div class='value'>${currentCycleStart} — ${currentCycleEnd}</div>
    </div>
    <div class='summary-card'>
      <div class='label'>Total Customers Changed</div>
      <div class='value'>${totalTransfers}</div>
    </div>
  </div>
  <h2>Transferred Customers</h2>
  <table>
    <thead>${headerRow}</thead>
    <tbody>${rows}</tbody>
  </table>
  <div class='footer'>SomWater Customer Transfer Report — Confidential | For Senior Management Review</div>
</body>
</html>`;

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();
  setTimeout(() => printWindow.print(), 150);
}
